import { render, staticRenderFns } from "./BaseS3FileDownloadButtonGroup.vue?vue&type=template&id=2ca5ffa9"
import script from "./BaseS3FileDownloadButtonGroup.vue?vue&type=script&lang=js"
export * from "./BaseS3FileDownloadButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports